import { PageSection } from "../../../components/page/page_section"
import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faMailBulk,
  faMapMarkerAlt,
  faPhone,
} from "@fortawesome/free-solid-svg-icons"

const VenueAboutItemStyled = styled.div`
  margin: 8px;
  display: flex;
  flex-direction: row;

  .icon {
    width: 16px;
    height: 16px;
    margin-right: 16px;
  }

  .label {
    margin-right: 16px;
  }

  .value {
    font-weight: bold;
    margin-right: 16px;
  }
`
const VenueAboutItem = ({ label, children, icon }) => {
  return (
    <VenueAboutItemStyled>
      <div className="icon">
        <FontAwesomeIcon icon={icon} />
      </div>
      <div className="label">{label}</div>
      <div className="value">{children}</div>
    </VenueAboutItemStyled>
  )
}

export const VenueSectionAbout = ({ venue }) => {
  return (
    // <PageSection>
    <>
      {venue.description && (
        <div
          style={{ marginBottom: 20 }}
          dangerouslySetInnerHTML={{ __html: venue.description }}
        />
      )}

      {/* <VenueAboutItem label="Telefon" icon={faPhone}>
        {venue.phone}
      </VenueAboutItem>

      <VenueAboutItem label="Mail" icon={faMailBulk}>
        {venue.email}
      </VenueAboutItem>
      <VenueAboutItem label="Adres" icon={faMapMarkerAlt}>
        {venue.address}
      </VenueAboutItem> */}
    </>
    // </PageSection>
  )
}
